import AdminContainer from "pages/Admin";

const privateRoutes = [
    { path: "admin/*", element: <AdminContainer/> }
];

export default privateRoutes;